import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const MaintenanceContext = createContext();

export const useMaintenance = () => useContext(MaintenanceContext);

export const MaintenanceProvider = ({ children }) => {
  const [maintenance, setMaintenance] = useState(false);
  const [checked, setChecked] = useState(false);

  const checkMaintenance = useCallback(async () => {
    try {
      const { data } = await api.get('/admin/maintenance');
      setMaintenance(data.maintenanceMode === true);
    } catch {
      setMaintenance(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    checkMaintenance();
    const interval = setInterval(checkMaintenance, 60000);
    return () => clearInterval(interval);
  }, [checkMaintenance]);

  return (
    <MaintenanceContext.Provider value={{ maintenance, checked, checkMaintenance }}>
      {children}
    </MaintenanceContext.Provider>
  );
};
